import PageTypeDialog from "Components/PageTypes/PageTypeDialog";
import { useState } from "react";
import { ApiPageType } from "@incendium/api";
import { useSelectedProject } from "Hooks";
import { usePageTypes } from "Hooks/usePageTypes";
import produce from "immer";
import { useSnackbar } from "notistack";
import PageTypesList from "Components/PageTypes/PageTypesList";
import { locationService } from "Apis";
import { useConfirmation } from "Hooks/useConfirmation";

function LocationTagsPage() {
  const { pageTypes, setPageTypes } = usePageTypes();
  const handleDelete = useConfirmation();
  const { selectedProject } = useSelectedProject();
  const [open, setOpen] = useState(false);
  const [pageType, setPageType] = useState<ApiPageType>({});
  const { enqueueSnackbar } = useSnackbar();

  const onNew = () => {
    setPageType({});
    setOpen(true);
  };

  const onEdit = (pageType: ApiPageType) => {
    setPageType(pageType);
    setOpen(true);
  };

  const onDelete = (pageType: ApiPageType) => {
    handleDelete({
      title: `Are you sure you want to delete this location tag`,
      body: "This action can not be undone",
      callback: async () => {
        await locationService.locationServiceDeletePageType({
          projectId: selectedProject?.id as number,
          pageTypeId: pageType.id as number,
        });

        setPageTypes(
          produce(pageTypes, (draft) => {
            const idx = pageTypes.findIndex((pt) => pt.id === pageType.id);
            if (idx !== -1) draft.splice(idx, 1);
          }),
        );
        return `Location Tag Deleted`;
      },
    });
  };

  const onSave = (pageType: ApiPageType) => {
    const idx = pageTypes.findIndex((pt) => pt.id === pageType.id);
    if (idx >= 0) {
      setPageTypes(
        produce(pageTypes, (draft) => {
          draft[idx] = pageType;
        }),
      );
    } else {
      setPageTypes(
        produce(pageTypes, (draft) => {
          draft.push(pageType);
        }),
      );
    }

    enqueueSnackbar(`Location Tag Saved`, {
      variant: "success",
      autoHideDuration: 2000,
      anchorOrigin: { horizontal: "right", vertical: "top" },
    });
  };

  return (
    <>
      <PageTypesList
        pageTypes={pageTypes}
        onEdit={onEdit}
        onDelete={onDelete}
        onNew={onNew}
      />

      <PageTypeDialog
        open={open}
        setOpen={setOpen}
        pageType={pageType}
        project={selectedProject || {}}
        onSaved={onSave}
      />
    </>
  );
}

export default LocationTagsPage;
